import { hasInAppHistory } from 'utils/hubReturnPath'

export const taskBackTarget = (location, trackerReturn, listPath) => {
  if (location?.state?.fromCreate) return { path: listPath, label: 'Back to tasks' }
  if (hasInAppHistory(location)) return { back: true, label: 'Go back' }
  if (trackerReturn) return { path: trackerReturn, inApp: true, label: 'Back to the compliance tracker' }
  return { path: listPath, label: 'Back to tasks' }
}
